<template>
  <el-dialog title="Alterar Reajuste/Renovação" :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" :append-to-body="true" v-loading="isLoading" width="500px">
    <el-form ref="form" size="small" :model="aluguelAlterado" :rules="validacao" label-position="top" required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-form-item label="Data Reajuste Atual">
            <el-date-picker
              v-model="aluguel.dataReajuste"
              v-mask="'##/##/####'"
              type="date"
              disabled
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nova Data Reajuste" prop="data1">
            <el-date-picker
              v-model="aluguelAlterado.dataReajuste"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-button @click="gravar" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      aluguelAlterado: {
        dataReajuste: this.aluguel.dataReajuste,
      },
     validacao: {
        data1: [{ required: true, len: 10}],
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore",["alterarDataReajuste"]),

    iniciar() {
     this.reset()
    },

    gravar(){
      if(!(this.aluguelAlterado.dataReajuste)){
        this.$message.info("Informe os dados obrigatórios");
        return
      }
      let payload = {
        id: this.aluguel.id,
        ...this.aluguelAlterado,
        dataReajusteAnterior: this.aluguel.dataReajuste
      }
      this.showLoading();
      this.alterarDataReajuste(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar()
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    
    reset() {
      this.aluguelAlterado = {
        dataReajuste: undefined,
      }
    },

    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
